export const CAMPAIGN_CONTENT_GENERATING_MESSAGES = [
  "Researching company signals...",
  "Analyzing buying intent & market signals...",
  "Checking ICP fitment...",
  "Crafting your pitch positioning...",
  "Hyper-personalizing your outreach...",
  "Adding relevant social proof...",
  "Optimizing email, LinkedIn & WhatsApp journeys...",
  "Aligning multi-channel messaging...",
  "Fine-tuning for better response rates...",
  "We're building your high-converting pitch...",
  "Almost there — making your outreach smarter...",
];

export const CAMPAIGN_CONTENT_DONE_MESSAGE =
  "Done — your personalized campaign is ready 🚀";

export const CAMPAIGN_CONTENT_GENERATING_TITLE =
  "Building your personalized campaign";

export const CAMPAIGN_CONTENT_MESSAGE_INTERVAL_MS = 2500;
export const CAMPAIGN_CONTENT_DONE_FLASH_MS = 1500;
export const CAMPAIGN_CONTENT_MAX_PROGRESS_WHILE_GENERATING = 92;
